import { ImageExtractionResponse } from '@wix/media-platform-js-client/dist/mjs/src/platform/management/responses/image-extraction-response';

import { getProjectByRoute } from '../../../../../redux/projects/projects.selectors';
import { Dispatch, GetState } from '../../../../../redux/redux.types';
import { getSelectedOrganizationId } from '../../../../../selectors/organizations/organizations';

import { extractImageById } from './image-features.services';

export const IMAGE_FEATURES_ACTIONS = {
  EXTRACT_IMAGE_START: 'IMAGE_FEATURES_ACTIONS.EXTRACT_IMAGE_START',
  EXTRACT_IMAGE_SUCCESS: 'IMAGE_FEATURES_ACTIONS.EXTRACT_IMAGE_SUCCESS',
  EXTRACT_IMAGE_ERROR: 'IMAGE_FEATURES_ACTIONS.EXTRACT_IMAGE_ERROR',
};

export const extractImage =
  (fileId: string) =>
  (
    dispatch: Dispatch,
    getState: GetState,
  ): Promise<ImageExtractionResponse | Error> => {
    const state = getState();
    const organizationId = getSelectedOrganizationId(state);
    const project = getProjectByRoute(state);
    if (!project) {
      return Promise.reject(
        'No selected project, this should normally not ever happen',
      );
    }

    return dispatch({
      types: [
        IMAGE_FEATURES_ACTIONS.EXTRACT_IMAGE_START,
        IMAGE_FEATURES_ACTIONS.EXTRACT_IMAGE_SUCCESS,
        IMAGE_FEATURES_ACTIONS.EXTRACT_IMAGE_ERROR,
      ],
      callApi: () => extractImageById({ fileId, organizationId, project }),
      additionalData: {
        fileId,
      },
    });
  };
